export const SET_MOBILE_STATE = "SET_MOBILE_STATE";
